import type { FC, SVGProps } from "react";
import SimpleIconsEthereum from "~icons/simple-icons/ethereum";
import AztecSymbol from "../../assets/aztec-symbol.svg?react";

export type BridgeType = "deposit" | "withdraw";

type Label = {
  type: string;
  transferFrom: string;
  transferTo: string;
  transferFromIcon: FC<SVGProps<SVGSVGElement>>;
  transferToIcon: FC<SVGProps<SVGSVGElement>>;
};

export const BRIDGE_LABELS: Record<BridgeType, Label> = {
  deposit: {
    type: "Deposit",
    transferFrom: "Ethereum",
    transferTo: "Aztec Network",
    transferFromIcon: SimpleIconsEthereum,
    transferToIcon: AztecSymbol,
  },
  withdraw: {
    type: "Withdraw",
    transferFrom: "Aztec Network",
    transferTo: "Ethereum",
    transferFromIcon: AztecSymbol,
    transferToIcon: SimpleIconsEthereum,
  },
} as const;

export const L1_CHAIN_ID = 31337;
